import { render, staticRenderFns } from "./management_page.vue?vue&type=template&id=9b46758a&"
import script from "./management_page.vue?vue&type=script&lang=js&"
export * from "./management_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports